import { Component, OnInit } from '@angular/core';
import { Episode } from '../models/episode.model';
import { Show } from '../models/show.model';
import {ActivatedRoute} from '@angular/router';
import {MatTableDataSource} from '@angular/material/table';
import {TvmazeService} from '../service/tvmaze.service';

@Component({
  selector: 'app-show-details',
  templateUrl: './show-details.component.html',
  styleUrls: ['./show-details.component.css']
})
export class ShowDetailsComponent implements OnInit {
  sid: string;
  show: Show;
  episodes: MatTableDataSource<Episode>;
  tableHeaders: Array<string>;
  constructor(private route: ActivatedRoute, private tvService: TvmazeService) {
    this.tableHeaders = ['number', 'name', 'aired', 'summary'];
  }

  ngOnInit(): void {
    this.route.params.subscribe((p) => {
      this.sid = p.id;
      this.tvService.getShowWithEps(this.sid).subscribe(results => {
          this.show = results.show;
          this.episodes = new MatTableDataSource(results.episodes);
        }
      );
    });
  }
  applyFilter(e: Event): void {
    const filterValue = (e.target as HTMLInputElement).value;
    this.episodes.filter = filterValue.trim().toLowerCase();
  }
}
